import {CardEnum, CardStateUnordered} from '@colonist/game-states'
import {StateCreator} from 'zustand'

export interface GameCardInventorySlice {
    gameCardInventory: {
        cardInventory: CardEnum[]
        setCardInventory: (cardInventory: CardEnum[]) => void
        selectedCards: CardEnum[]
        cardsToGreyOut: CardStateUnordered | undefined
        setCardsToGreyOut: (cardsToGreyOut: CardStateUnordered | undefined) => void
        setSelectedCards: (selectedCards: CardEnum[]) => void
        onSelectCardForTrade: ((card: CardEnum) => void) | undefined
        setOnSelectCardForTrade: (onSelectCardForTrade: (card: CardEnum) => void) => void
        onSelectCardForActionBox: ((card: CardEnum) => void) | undefined
        setOnSelectCardForActionBox: (onSelectCardForActionBox: (card: CardEnum) => void) => void
    }
}

export const createGameCardInventorySlice = (): StateCreator<GameCardInventorySlice> => (set, get) => ({
    gameCardInventory: {
        cardInventory: [],
        setCardInventory: (cardInventory: CardEnum[]) => {
            set({gameCardInventory: {
                ...get().gameCardInventory,
                cardInventory: cardInventory,
            }})
        },
        selectedCards: [],
        setSelectedCards: (selectedCards: CardEnum[]) => {
            set({gameCardInventory: {
                ...get().gameCardInventory,
                selectedCards: selectedCards,
            }})
        },
        cardsToGreyOut: [],
        setCardsToGreyOut: (cardsToGreyOut: CardStateUnordered | undefined) => {
            set({gameCardInventory: {
                ...get().gameCardInventory,
                cardsToGreyOut: cardsToGreyOut,
            }})
        },
        onSelectCardForTrade: undefined,
        setOnSelectCardForTrade: (onSelectCardForTrade: (card: CardEnum) => void) => {
            set({gameCardInventory: {
                ...get().gameCardInventory,
                onSelectCardForTrade: onSelectCardForTrade,
            }})
        },
        onSelectCardForActionBox: undefined,
        setOnSelectCardForActionBox: (onSelectCardForActionBox: (card: CardEnum) => void) => {
            set({gameCardInventory: {
                ...get().gameCardInventory,
                onSelectCardForActionBox: onSelectCardForActionBox,
            }})
        },
    },
})
